// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"833":"6db72ddc7ece34cbcd82","913":"5927437b31129e7fbc74","926":"5f6fb67fad17f23d2cbd"}[chunkId] + ".chunk.js";
};